import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTitleSubtitle,
  ApexStroke,
  ApexGrid,
  ApexFill,
  ApexMarkers,
  ApexYAxis
} from "ng-apexcharts";
import { EventService } from 'src/app/services/event.service';
import { convertNum, convertNumToCurr } from 'src/app/shared/constants/app-enums';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  grid: ApexGrid;
  fill: ApexFill;
  markers: ApexMarkers;
  yaxis: ApexYAxis;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
};


@Component({
  selector: 'app-revenue-chart',
  templateUrl: './revenue-chart.component.html',
  styleUrls: ['./revenue-chart.component.scss']
})


export class RevenueChartComponent implements OnChanges {

  @Input('chartIndex') chartIndex: number = 0;
  @Input('chartData') chartData: any;
  max = 0;
  lang: any = localStorage.getItem('currentlang');

  cData: any;
  isMobile = (window.matchMedia && window.matchMedia('(max-device-width: 1024px)').matches) || screen.width <= 1024;
  chartOptions: Partial<ChartOptions> | any;
  

  constructor(
    private eventService: EventService
  ) {
    this.eventService.getLang().subscribe((val) => {
      this.lang = val || 'en';
      this.initChartOptions();
      this.updateData();
    });
    this.initChartOptions();
  }

  initChartOptions() {
    this.chartOptions = {
      series: [
        {
          name: "",
          data: []
        },
      ],
      chart: {
        height: 200,
        type: "line",
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        },
      },
      stroke: {
        width: 3,
        curve: 'smooth',
        lineCap: 'butt',
        colors: ["#00AEFF","#72F238"],
        dashArray: 0,
      },
      markers: {
        size: 0,
        discrete: [
          {
            seriesIndex: 0,
            dataPointIndex: 29,
            fillColor: "#00AEFF",
            size: 4,
            strokeColor: "#B2E7FF",
            strokeWidth: 20,
            strokeOpacity: 0.1
          }
        ]
      },
      yaxis: {
        tickAmount: 4,
        min: (minValue: any) => {
          return Math.max(0, minValue);
        },
        labels: {
          show: true,
          maxWidth: 50,
          minWidth: 0,
          padding: (this.lang == "ar" || this.lang == "fa") ? -20 : 10,
          formatter: function (value: any) {
            return convertNumToCurr(value);
          },
          style: {
            fontSize: '9px',
            fontWeight: 300,
            color:"#6F717E",
          },
        },
      },
      xaxis: {
        type: "datetime",
        // categories: [],
        labels: {
          format: 'dd/MM',
          style: {
            fontSize: '9px',
            fontWeight: 300,
            color:"#6F717E"
          },
        },
      },
      grid: {
        borderColor: '#A0A2AA',
        strokeDashArray: 8,
        padding: {
          left: 5,
          right: 5
        }
      }
    };
  }

  ngOnChanges(changes: SimpleChanges):void {
    this.updateData();
  }

  updateData() {
    // console.log('changes', changes)
    this.cData = this.chartData[this.chartIndex];
    this.chartOptions.series[0].data = this.cData.chartData.map((indx: any)=> [new Date(indx.date), indx.usd]).reverse();
    // this.chartOptions.series[1].data = this.cData.chartData.map((indx: any)=> [new Date(indx.date),(+indx.usd110/1000).toFixed(2)]).reverse();
    // console.log('---------',this.chartOptions.series[0].data)
    // console.log('---------',this.chartOptions.series[1].data)
    this.chartOptions.series[0].data.forEach((element: any) => {
        this.max = Math.max(this.max, element[1]);
    });
    this.chartOptions.yaxis.max = this.max;
  }

  convertNum(num: number, dec=2) {
    return convertNum(num, dec);
  }
}
